import { normalizeToUTC } from "@revbox/helpers-fe";
import axiosInstance from "../../axios/instance";
import { getToken } from "../../helpers/get-token";
import { endOfDay, startOfDay } from "date-fns";

async function getPeriodInventoryPerformance(
    currentPeriod,
    previousPeriod,
    status = null,
    search = "",
    page = 1,
    inventoryId = null,
    sortingParams = null
) {
    try {
        const token = getToken();
        axiosInstance.defaults.headers.common['authorization'] = token;

        let url = new URL(`${process.env.REACT_APP_HUB_URL}/api/analytics/inventory/period/performance`);

        const queryParams = {
            page,
            search,
            inventory_id: inventoryId,
            status
        };

        if (sortingParams?.columnName) {
            queryParams.column_name = sortingParams?.columnName;
        }

        if (sortingParams?.sortOrder) {
            queryParams.column_order = sortingParams?.sortOrder;
        }

        Object.entries(queryParams).forEach(([key, value]) => {
            if (value !== null && value !== "") url.searchParams.set(key, value);
        });

        const response = await axiosInstance.post(url.toString(), {
            current_period: [
                startOfDay(normalizeToUTC(currentPeriod[0])),
                endOfDay(normalizeToUTC(currentPeriod[1]))
            ],
        });

        return response?.data || {
            data: [],
            total: 0,
            totalRecords: 0,
            liveRecords: 0,
            draftRecords: 0,
        };
    } catch (error) {
        console.log(error);
    }
}

export default getPeriodInventoryPerformance;
